import React from 'react';
import { PageProps } from '../Page.types';
import AuthRedirect from '../AuthRedirect/AuthRedirect';

const Login: React.FC<PageProps> = () => {
  return <AuthRedirect />;
};

export default Login;
